/** @jsx jsx */
import { darken } from 'polished';
import { merge } from 'lodash';
import { Colors } from '@zapier/theme';
import { jsx, Interpolation } from '@emotion/core';
import FacebookIcon from './FacebookIcon';
import { SSOButton, getStartUrlForProvider } from '../SSOButton';

const defaultSSOButtonCSS = {
  alignItems: 'center',
  backgroundColor: Colors.white,
  border: `1px solid ${Colors.adamantium}`,
  borderRadius: '4px',
  boxShadow: '0 0 1px rgba(#000, 0.12), 0 1px 1px rgba(#000, 0.24)',
  color: '#4d4d4d',
  display: 'flex',
  fontSize: 13,
  fontWeight: 'bold',
  padding: 10,
  position: 'relative' as 'relative',
  ':hover,:focus': {
    background: darken(0.03, Colors.white),
    textDecoration: 'none',
  },
} as const;

export type FacebookSSOButtonProps = {
  label?: string;
  href?: string;
  next?: string;
  onTrackSignupConversion?: (customUserId: string) => void | Promise<void>;
  onTrackSignupIntent?: () => void;
  passThrough?: boolean;
  shouldOpenInChildWindow?: boolean;
};

// The constants below are from Facebook Guidelines
const FACEBOOK_BLUE = '#3b5999';
const FACEBOOK_BOX_SHADOW =
  '0 0 1px rgba(#000, 0.12), 0 1px 1px rgba(#000, 0.24)';

const labelCss: Interpolation = {
  flex: 1,
  marginLeft: '-2rem', // compensate the logo to look like centered
  textAlign: 'center',
};

const defaultCss = merge(defaultSSOButtonCSS, {
  backgroundColor: FACEBOOK_BLUE,
  border: 'none',
  boxShadow: FACEBOOK_BOX_SHADOW,
  color: Colors.white,
  WebkitTextFillColor: Colors.white,
  ':hover,:focus': {
    backgroundColor: FACEBOOK_BLUE,
    color: Colors.white,
    WebkitTextFillColor: Colors.white,
  },
});

const href = getStartUrlForProvider('facebook');

const FacebookSSOButton = ({ label, ...props }: FacebookSSOButtonProps) => {
  return (
    <SSOButton href={href} {...props}>
      <span css={defaultCss}>
        <FacebookIcon />
        <span css={labelCss}>{label}</span>
      </span>
    </SSOButton>
  );
};

FacebookSSOButton.defaultProps = {
  label: 'Continue with Facebook',
};

export default FacebookSSOButton;
